import request from '@/utils/request'

/**
 * 查询客户催单列表
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function queryStoreOrderCartEvent(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/storeOrder/queryStoreOrderCartEvent',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}